import script from "./PageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PageItem.vue?vue&type=script&setup=true&lang=js"

import "./PageItem.vue?vue&type=style&index=0&id=5551fb17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5551fb17"]])

export default __exports__